module.exports = __webpack_public_path__ + "static/media/logo_track_azul.9492ea0d.png";